<template>
  <v-expansion-panel class="mt-3">
    <v-expansion-panel-header>
      <slot name="title"></slot>
    </v-expansion-panel-header>
    <v-expansion-panel-content class="signLine-content">
      <!-- 결재선 -->
      <slot name="component"></slot>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
export default {};
</script>

<style></style>
